import { render } from "./StepFirstItem.vue?vue&type=template&id=52b83ca9"
import script from "./StepFirstItem.vue?vue&type=script&lang=js"
export * from "./StepFirstItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__